<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 24 24">
    <g transform="translate(2.5 0.1) rotate(15) scale(0.215 0.215)">
      <path
        d="M 60.453 29.767 c -4.971 -4.454 -11.394 -6.499 -18.088 -5.76 c -11.024 1.218 -19.632 10.146 -20.469 21.229 c -0.504 6.674 1.879 13.233 6.537 17.996 c 2.02 2.065 3.132 4.903 3.132 7.991 v 15.05 c 0 2.055 1.672 3.727 3.727 3.727 h 19.415 c 2.055 0 3.727 -1.672 3.727 -3.727 V 70.989 c 0 -2.91 1.117 -5.713 3.066 -7.688 c 4.303 -4.363 6.672 -10.141 6.672 -16.268 C 68.172 40.453 65.358 34.16 60.453 29.767 z"
        fill="none"
        :stroke="iconFill"
        stroke-width="1.5"
      />

      <path
        d="M 56.434 72.224 v 3.963 h -3.417 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 3.417 v 3.963 H 33.566 v -3.963 H 47.59 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 33.566 v -3.963 H 56.434 z"
        fill="none"
        :stroke="iconFill"
        stroke-width="1.5"
      />
      <path
        d="M 54.707 88 H 35.292 c -0.952 0 -1.727 -0.774 -1.727 -1.727 v -2.124 h 22.868 v 2.124 C 56.434 87.226 55.659 88 54.707 88 z"
        fill="none"
        :stroke="iconFill"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '24',
    },
    width: {
      type: String,
      default: '24',
    },
    color: {
      type: String,
      default: 'primary-gray-700',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconFill() {
      return `var(--${this.color})`
    },
  },
}
</script>
